import { mailboxHooks } from 'features/messaging'

import { api } from '../api'

export function useMostRelevant(withRefetch = false) {
	const participant = mailboxHooks.useConversationalist()
	const conversation = mailboxHooks.useCurrentId()

	const skip = !(participant?.entityId && conversation)

	return api.useMostRelevantExecutionQuery(
		{
			contact_entity_id: participant?.entityId ?? '',
			conversation_id: conversation
		},
		{
			refetchOnMountOrArgChange: withRefetch,
			skip
		}
	)
}
